import {Component, EventEmitter, OnDestroy, OnInit, Output, ViewEncapsulation} from '@angular/core';
import {Router} from '@angular/router';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';

import {fuseAnimations} from '@fuse/animations';

import { locale as polish } from './i18n/pl';
import { locale as english } from './i18n/en';
import {FuseTranslationLoaderService} from "../../../../@fuse/services/translation-loader.service";
import {CategoryService} from "../../services/category.service";
import {Category} from "../../models/category";
import {DiscountsDialogComponent} from "../dialog/discountsDialog/discountsDialog.component";
import {FormGroup} from "@angular/forms";
import {MatDialog} from "@angular/material/dialog";
import {VoucherTemplateGroup} from "../../models/voucherTemplateGroup";
import {VoucherTemplate} from "../../models/voucherTemplate";

@Component({
    selector: 'pos-navbar',
    templateUrl: './posNavbar.component.html',
    styleUrls: ['./posNavbar.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations
})
export class PosNavbarComponent implements OnInit, OnDestroy {
    folders: any[];
    filters: any[];
    tags: any[];
    accounts: object;
    selectedAccount: string;
    loadingIndicator: boolean;
    categories: Category[] = [];
    voucherGroups: VoucherTemplateGroup[] = [];
    filterValue: string = 'all';
    selectedVoucherGroupId: string | null = null;
    discountsDialogRef: any;

    @Output() filterItems = new EventEmitter<string>();
    @Output() filterItemsByCategory = new EventEmitter<string>();
    @Output() filterItemsByVoucherGroup = new EventEmitter<string>();
    @Output() loadVoucherGroups = new EventEmitter<VoucherTemplate[]>();

    // Private
    private _unsubscribeAll: Subject<any>;

    constructor(
        public _matDialog: MatDialog,
        private _router: Router,
        private translationLoader: FuseTranslationLoaderService,
        private categoryService: CategoryService,
    ) {
        // Set the private defaults
        this._unsubscribeAll = new Subject();
        this.loadingIndicator = true;

        this.translationLoader.loadTranslations(polish, english);
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {

    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    filterPostItems(id: string|null): void {
        this.categories = [];
        this.selectedVoucherGroupId = null;
        this.filterItems.emit(id);

        this.filterValue = id;

        // if (id === 'products') {
        //     this.categoryService.getAllByType('product').subscribe((res: any[]) => {
        //         this.categories = res;
        //     }, error => {
        //     })
        // }
    }

    updateVoucherGroups(voucherTemplates: VoucherTemplate[]): void {
        // Extract unique groups from voucher templates
        const groupsMap = new Map<string, VoucherTemplateGroup>();

        voucherTemplates.forEach(voucher => {
            if (voucher.group && voucher.group.id) {
                groupsMap.set(voucher.group.id, voucher.group);
            }
        });

        this.voucherGroups = Array.from(groupsMap.values());
    }

    filterPostItemsByCategory(id: string|null): void {
        this.filterItemsByCategory.emit(id);

        this.categoryService.getAllByType('product').subscribe((res: any[]) => {
            this.categories = res;
        }, error => {
        })
    }

    filterPostItemsByVoucherGroup(groupId: string | null): void {
        this.selectedVoucherGroupId = groupId;
        this.filterItemsByVoucherGroup.emit(groupId);
    }

    showDiscountsDialog() {
        this.discountsDialogRef = this._matDialog.open(DiscountsDialogComponent, {
            panelClass: 'discounts-dialog',
            data      : {
                action : 'show',
            },
            width: '900px',
        });

        this.discountsDialogRef.afterClosed()
            .subscribe((response: FormGroup) => {
                if (!response) {
                    return;
                }

                this.discountsDialogRef.close();

            }, (err) => {
                console.log(err);
            });
    }

}
